import { isStandalone } from '@digital-retail/store-manager';
import getConfig from 'next/config';
import PropTypes from 'prop-types';
import apiConfig from '../../config/api/apiConfig';
import constants from '../../config/constants';
import { withApplicationContext } from '../../utils/ApplicationContext';
import _ from '../../utils/LodashImports';
import { withProduct } from '../../utils/ProductContext';
import { getMeasurements } from '../../utils/variant';
import ShareButton from '../ShareButton/ShareButton';
import RatingsNumeric from '../ui/RatingsNumeric/RatingsNumeric';
import Reviews from '../ui/Reviews/Reviews';
import { BrandNameStyle, ProductNameStyle, ReviewAndRatingsStyle, ShareIconStyle, VariantIdStyle } from './index.style';

const { publicRuntimeConfig } = getConfig();

export const ProductName = withProduct(({ productName, product }) => {
  const { isOutOfStock } = product;
  const measurements = getMeasurements({ product });
  return (
    <div className="product-name-wrapper">
      <h1 data-name={productName} className={`product-name fa--product-name ${isOutOfStock && 'out-of-stock'}`}>
        {productName}
      </h1>
      <h2 className="product-format">{measurements?.formato}</h2>
      <style jsx>{ProductNameStyle}</style>
    </div>
  );
});

ProductName.propTypes = {
  productName: PropTypes.string.isRequired,
};

export const BrandName = withProduct(
  withApplicationContext(({ brandName, appCtx, product }) => {
    const { regionCode, store, deviceType } = appCtx;
    const env = publicRuntimeConfig?.ENVIRONMENT || 'production';
    const { isOutOfStock } = product;
    const isStandaloneStore = isStandalone({ store });
    const isDesktop = deviceType === constants.DEVICE_DESKTOP;
    const hideBrandStores = ['fa_america', 'fa_carters', 'fa_aldo', 'fa_crabarr', 'fa_thedrop'];
    const shouldHideBrandInMobile = !isDesktop && hideBrandStores.includes(store);

    if ((!isDesktop && !isStandaloneStore && brandName?.toLowerCase() === 'generico') || shouldHideBrandInMobile) {
      return null;
    }

    return (
      <div data-brand={brandName} className={`product-brand fa--brand ${isOutOfStock && 'out-of-stock'}`}>
        <a
          id="pdp-product-brand-link"
          className="product-brand-link"
          href={apiConfig.getBrandURL({
            brandName: brandName.toUpperCase(),
            regionCode,
            env,
            store,
          })}
        >
          {brandName}
        </a>
        <style jsx>{BrandNameStyle}</style>
      </div>
    );
  })
);

BrandName.propTypes = {
  brandName: PropTypes.string.isRequired,
  appCtx: PropTypes.string.isRequired,
};

export const VariantId = ({ variantId, labels, isSoCom = false }) => {
  const productCodeText = isSoCom ? _.get(labels, 'SO_COM_PRODUCT_CODE', 'Cód. del producto') : labels.PRODUCT_CODE;
  return (
    <>
      <div data-id={variantId} className="variant-id fa--variant-id">
        {' '}
        <span>{`${productCodeText}: ${variantId}`}</span>
      </div>
      <style jsx>{VariantIdStyle}</style>
    </>
  );
};

export const SellerSkuId = ({ sellerSkuId, labels }) => {
  const label = labels.SELLER_SKU_ID || 'Cód. tienda';
  return (
    <>
      <div data-id={sellerSkuId} className="variant-id fa--variant-id">
        {' '}
        <span>{`${label}: ${sellerSkuId}`}</span>
      </div>
      <style jsx>{VariantIdStyle}</style>
    </>
  );
};

VariantId.propTypes = {
  variantId: PropTypes.string.isRequired,
  labels: PropTypes.object.isRequired,
  isSoCom: PropTypes.bool.isRequired,
};

SellerSkuId.propTypes = {
  sellerSkuId: PropTypes.string.isRequired,
  labels: PropTypes.object.isRequired,
};

export const ReviewsAndRatings = ({ totalReviews, ratings, labels }) => {
  return (
    <>
      <RatingsNumeric maximum={5} value={ratings} />
      <div className="more-comments-scroll">
        <Reviews value={totalReviews} layout="PDP" />
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a href="#" className="pod-link">
          {labels.SEE_COMMENTS}
        </a>
      </div>
      <style jsx>{ReviewAndRatingsStyle}</style>
    </>
  );
};

ReviewsAndRatings.propTypes = {
  totalReviews: PropTypes.number.isRequired,
  ratings: PropTypes.number.isRequired,
  labels: PropTypes.object.isRequired,
};

export const ProductShareIcon = () => {
  return (
    <ShareButton>
      <div className="product-share-icon rebranded" />
      <style jsx>{ShareIconStyle}</style>
    </ShareButton>
  );
};
